import { render, staticRenderFns } from "./purchaseOrderDetail.vue?vue&type=template&id=0dc351a2&"
import script from "./js/purchaseOrderDetail.js?vue&type=script&lang=js&"
export * from "./js/purchaseOrderDetail.js?vue&type=script&lang=js&"
import style0 from "./css/purchaseOrderDetail.css?vue&type=style&index=0&lang=css&"
import style1 from "./css/common.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports